import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAgentOpen: false,
};

const agentSlice = createSlice({
  name: 'leeAIAgent',
  initialState,
  reducers: {
    toggleAgentSidebar: (state) => {
      state.isAgentOpen = !state.isAgentOpen;
    },
    setAgentOpen: (state, { payload }) => {
      state.isAgentOpen = payload;
    },
    closeAgentSidebar: (state) => {
      state.isAgentOpen = false;
    },
  },
});

export const {
  toggleAgentSidebar,
  setAgentOpen,
  closeAgentSidebar,
} = agentSlice.actions;

export default agentSlice.reducer;
